import {Injectable} from '@angular/core';
import {Effect, Actions} from '@ngrx/effects';
import * as dashboardAction from '../actions/dashboard.action';
import {map, switchMap, mergeMap} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {Action, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import * as fromStore from '../../../store';
import {DashboardService} from '../../dashboard.service';


@Injectable()
export class DashboardEffett {
  constructor(private actions: Actions, private dashboardService: DashboardService, private store: Store<fromStore.AppState>) {
  }


  @Effect()
  getDashboardDetails: Observable<Action> = this.actions.ofType(dashboardAction.GET_DASHBOARD_DETAILS)
    .map((action: dashboardAction.GetDashboardDetails) => action.payload)
    .pipe(
      mergeMap(body => {
        return this.dashboardService.getDashboardDetails(body)
          .map(res => new dashboardAction.GetDashboardDetailsSuccess(res))
          .catch(error => of(new dashboardAction.GetDashboardDetailsError(error)));
      })
  );

}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/dashboard/store/effects/dashboard.effect.ts